import { MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { ContactUsData, SubjectList } from "src/assets/data";
import { BaseBTN } from "src/components/ui";
import { contact_us } from "src/utils/validations/ContactUsValidate";
import useGetActiveCategoryList from "../../../../services/welcome/useGetActiveCategoryList";
import useCreateContactUs from "../../../../services/welcome/useCreateContactUs";
import useGetActiveSubcategoryList from "../../../../services/welcome/useGetActiveSubcategoryList";

const ContactUsForm = ({ newTheme }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const { data: categoryData } = useGetActiveCategoryList();
  const { data: subcategoryData } = useGetActiveSubcategoryList(selectedCategory, "خارج از سامانه");

  const { createContactUs } = useCreateContactUs();

  const initialValues = {
    firstName: "",
    lastName: "",
    title: "",
    businessTitle: "",
    phoneNumber: "",
    email: "",
    subject: "",
    category: "",
    subcategory: "",
    text: "",
  };

  const onSubmit = (values, { resetForm }) => {
    createContactUs(values);
    resetForm();
  };

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={contact_us}>
      {({ isValid, values, setFieldValue }) => (
        <Form>
          <Stack spacing={2} width={"420px"}>
            <Stack spacing={2} direction="row" justifyContent="center" alignItems="top">
              <Stack width="100%" spacing={0.5} textAlign="left">
                <Typography color={"white"} variant="body1" fontWeight={400}>
                  نام
                  <Typography component="span" color="error.main">
                    *
                  </Typography>
                </Typography>
                <Field
                  as={TextField}
                  name="firstName"
                  placeholder="مثال: علی"
                  variant="outlined"
                  sx={{
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#091D35",
                    },
                  }}
                />
                <ErrorMessage name="firstName" component={Typography} color="error.main" variant="caption" />
              </Stack>
              <Stack width="100%" spacing={0.5} textAlign="left">
                <Typography color={"white"} variant="body1" fontWeight={400}>
                  نام خانوادگی
                  <Typography component="span" color="error.main">
                    *
                  </Typography>
                </Typography>
                <Field
                  as={TextField}
                  name="lastName"
                  placeholder="مثال: متین"
                  variant="outlined"
                  sx={{
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#091D35",
                    },
                  }}
                />
                <ErrorMessage name="lastName" component={Typography} color="error.main" variant="caption" />
              </Stack>
            </Stack>

            <Stack spacing={2} direction="row" justifyContent="center" alignItems="top">
              <Stack width="100%" spacing={1} textAlign="left">
                <Typography color={"white"} variant="body1" fontWeight={400}>
                  عنوان کسب و کار
                </Typography>
                <Field
                  as={TextField}
                  name="businessTitle"
                  placeholder="عنوان کسب‌وکار خود را وارد کنید."
                  variant="outlined"
                  sx={{
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#091D35",
                    },
                  }}
                />
                <ErrorMessage name="businessTitle" component={Typography} color="error.main" variant="caption" />
              </Stack>
              <Stack width="100%" spacing={0.5} textAlign="left">
                <Typography color={"white"} variant="body1" fontWeight={400}>
                  عنوان پیام
                  <Typography component="span" color="error.main">
                    *
                  </Typography>
                </Typography>
                <Field
                  as={TextField}
                  name="title"
                  placeholder="عنوان پیام را وارد کنید"
                  variant="outlined"
                  sx={{
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#091D35",
                    },
                  }}
                />
                <ErrorMessage name="title" component={Typography} color="error.main" variant="caption" />
              </Stack>
            </Stack>

            <Stack width="100%" textAlign="left" flexDirection={"column"}>
              <Typography color={"white"} variant="body1" fontWeight={400}>
                موضوع
                <Typography component="span" color="error.main">
                  *
                </Typography>
              </Typography>
              <Field
                as={Select}
                name="subject"
                id="subject"
                displayEmpty
                value={values?.subject}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#091D35",
                    borderRadius: "10px",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#0b2545",
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#0f2e5c",
                    },
                    "&.Mui-error": {
                      border: "1px solid red",
                    },
                  },
                  "& .MuiSelect-select": {
                    color: "white",
                    borderRadius: "10px",
                    backgroundColor: "#091D35",
                  },
                  "& .MuiSelect-icon": {
                    color: "white", // رنگ فلش ▼
                  },
                  "& .Mui-error": {
                    color: "red",
                  },
                  "& .MuiInputBase-root": {
                    backgroundColor: "#0f2e5c",
                  },
                }}
              >
                <MenuItem disabled value="">
                  <Typography color={"grey.gm"}>موضوع را انتخاب کنید.</Typography>
                </MenuItem>
                {SubjectList?.map((item) => (
                  <MenuItem key={item?.value} value={item?.value}>
                    {item?.label}
                  </MenuItem>
                ))}
              </Field>

              <ErrorMessage name="subject" component={Typography} color="error.main" variant="caption" />
            </Stack>

            <Stack spacing={2} direction="row" justifyContent="center" alignItems="top">
              <Stack width="100%" textAlign="left" flexDirection={"column"}>
                <Typography color={"white"} variant="body1" fontWeight={400}>
                  دسته‌بندی
                  <Typography component="span" color="error.main">
                    *
                  </Typography>
                </Typography>
                <Field
                  as={Select}
                  displayEmpty
                  variant="outlined"
                  name="category"
                  id="category"
                  value={values?.category}
                  placeholder="دسته مورد نظرتان را انتخاب کنید."
                  onChange={(e) => {
                    setFieldValue("category", e.target.value);
                    setSelectedCategory(e.target.value);
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      backgroundColor: "#091D35",
                      borderRadius: "10px",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#0b2545",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#0f2e5c",
                      },
                      "&.Mui-error": {
                        border: "1px solid red",
                      },
                    },
                    "& .MuiSelect-select": {
                      color: "white",
                      borderRadius: "10px",
                      backgroundColor: "#091D35",
                    },
                    "& .MuiSelect-icon": {
                      color: "white",
                    },
                    "& .Mui-error": {
                      color: "red",
                    },
                    "& .MuiInputBase-root": {
                      backgroundColor: "#0f2e5c",
                    },
                  }}
                >
                  <MenuItem disabled value="">
                    <Typography color={"grey.gm"}> دسته را انتخاب کنید.</Typography>
                  </MenuItem>
                  {categoryData?.activeCategoryList?.edges?.map((item) => (
                    <MenuItem key={item.node.id} value={item.node.id}>
                      {item.node.title}
                    </MenuItem>
                  ))}
                </Field>

                <ErrorMessage name="category" component={Typography} color="error.main" variant="caption" />
              </Stack>
              <Stack width="100%" textAlign="left" flexDirection={"column"}>
                <Typography color={"white"} variant="body1" fontWeight={400}>
                  زیردسته
                  <Typography component="span" color="error.main">
                    *
                  </Typography>
                </Typography>
                <Field
                  as={Select}
                  displayEmpty
                  variant="outlined"
                  name="subcategory"
                  value={values?.subcategory}
                  placeholder="زیردسته مورد نظرتان را انتخاب کنید."
                  onChange={(e) => {
                    setFieldValue("subcategory", e.target.value);
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#091D35",
                      borderRadius: "10px",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#0b2545",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#0f2e5c",
                      },
                      "&.Mui-error": {
                        border: "1px solid red",
                      },
                    },
                    "& .MuiSelect-select": {
                      color: "white",
                      borderRadius: "10px",
                      backgroundColor: "#091D35",
                    },
                    "& .MuiSelect-icon": {
                      color: "white",
                    },
                    "& .Mui-error": {
                      color: "red",
                    },
                    "& .MuiInputBase-root": {
                      backgroundColor: "#0f2e5c",
                    },
                  }}
                >
                  <MenuItem disabled value="">
                    <Typography color={"grey.gm"}>زیردسته را انتخاب کنید.</Typography>
                  </MenuItem>
                  {subcategoryData?.activeSubcategoryList?.edges?.map((item) => (
                    <MenuItem key={item.node.id} value={item.node.id}>
                      {item.node.title}
                    </MenuItem>
                  ))}
                </Field>

                <ErrorMessage name="subcategory" component={Typography} color="error.main" variant="caption" />
              </Stack>
            </Stack>

            <Stack spacing={2} direction="row" justifyContent="center" alignItems="top">
              <Stack width="100%" textAlign="left">
                <Typography color={"white"} variant="body1" fontWeight={400}>
                  {ContactUsData.contactNumLabel}
                  <Typography component="span" color="error.main">
                    *
                  </Typography>
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  name="phoneNumber"
                  inputProps={{
                    maxLength: 11,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  onKeyDown={(e) => {
                    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                      e.preventDefault(); // فقط اعداد و کلیدهای کنترلی مجازن
                    }
                  }}
                  onPaste={(e) => {
                    const pasted = e.clipboardData.getData("Text");
                    if (!/^\d+$/.test(pasted)) {
                      e.preventDefault(); // اگر متن پیست‌شده عدد نبود، جلوگیری می‌کنیم
                    }
                  }}
                  placeholder={ContactUsData.contactNumPlaceHolder}
                  variant="outlined"
                  sx={{
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#091D35",
                    },
                  }}
                />
                <ErrorMessage name="phoneNumber" component={Typography} color="error.main" variant="caption" />
              </Stack>
              <Stack width="100%" textAlign="left">
                <Typography color={"white"} variant="body1" fontWeight={400}>
                  {ContactUsData.emailLabel}
                  <Typography component="span" color="error.main">
                    *
                  </Typography>
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  name="email"
                  placeholder={ContactUsData.emailPlaceHolder}
                  variant="outlined"
                  sx={{
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#091D35",
                    },
                  }}
                />
                <ErrorMessage name="email" component={Typography} color="error.main" variant="caption" />
              </Stack>
            </Stack>

            <Stack width="100%" spacing={0.5} textAlign="left">
              <Typography color={"white"} variant="body1" fontWeight={400}>
                متن پیام
                <Typography component="span" color="error.main">
                  *
                </Typography>
              </Typography>
              <Field
                as={TextField}
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                name="text"
                placeholder={ContactUsData.messagePlaceHolder}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#091D35",
                  },
                }}
              />
              <ErrorMessage name="text" component={Typography} color="error.main" variant="caption" />
            </Stack>

            <BaseBTN
              color="primary"
              variant="contained"
              fullWidth
              type="submit"
              disabled={!isValid}
              sx={{ backgroundColor: newTheme.text.color.primary }}
            >
              {ContactUsData.sendMessageBtn}
            </BaseBTN>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};
export default ContactUsForm;
